<template>
  <div id="app" v-if="!inLocalIframe">
    <toolbar ref="toolbar" :key="componentKey" @forceRerender="forceRerender"></toolbar>
    <router-view :class="{'shiftAppUp print-bg': isShifted}"></router-view>
    <onboarding></onboarding>
    <open-in-app @isVisible="seenOpenInApp = true" v-if="!$isAjas"></open-in-app>
    <nav-footer ref="footer"></nav-footer>
  </div>
</template>

<script>
import breakpoints from '@/libs/breakpoints'
import Onboarding from '@/components/Controls/Onboarding'
import app from './mixins'

export default {
  components: {
    Onboarding
  },
  mixins: [app],
  data: function () {
    return {
      componentKey: 0
    }
  },
  computed: {
    isShifted: function () {
      return !this.seenOpenInApp && this.$route.name !== 'messaging' && this.$route.name !== 'publicMessaging' && this.$route.name !== 'about' && this.$route.name !== 'partners' && this.$route.name !== 'halloweenContest'
    },
    isTouch: function () {
      return breakpoints.isTouch()
    }
  },
  beforeMount: function () {
    if (breakpoints.isTouch()) {
      this.$store.dispatch('initMakeMobileOnboarding')
    } else {
      this.$store.dispatch('initMakeDesktopOnboarding')
    }
  },
  mounted: function () {
    this.initCallbacks()
  },
  watch: {
    maintenanceMode: function (current, old) {
      if (current && !old) {
        // if we're already on maintenance, we must be mid-route change
        // add a delay so the route push actually works
        let delay = 0
        if (this.$route.name === 'Maintenance') {
          delay = 5000
        }
        setTimeout(() => {
          this.$router.push({ name: 'Maintenance' })
        }, delay)
      }
    }
  },
  methods: {
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    },
    forceRerender () {
      const key = this.refreshKey()
      this.componentKey = key
    },
    checkUserLanguage: function () {
      this.$refs.footer.checkLanguage()
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
@import "./makeStyles.scss";
</style>
